/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HarvestBasicResponse } from '../../models/harvest-basic-response';
import { HarvestCloseRequest } from '../../models/harvest-close-request';

export interface CloseHarvest$Params {
  harvestId: number;
      body: HarvestCloseRequest
}

export function closeHarvest(http: HttpClient, rootUrl: string, params: CloseHarvest$Params, context?: HttpContext): Observable<StrictHttpResponse<HarvestBasicResponse>> {
  const rb = new RequestBuilder(rootUrl, closeHarvest.PATH, 'put');
  if (params) {
    rb.path('harvestId', params.harvestId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<HarvestBasicResponse>;
    })
  );
}

closeHarvest.PATH = '/api/harvests/{harvestId}/close-harvest';
